import { connect } from 'react-redux';
import AppointmentData from './AppointmentData';
import { updateAppointmentBegin } from '../../../../store/actions/person.actions';

const mapDispatchToProps = {
    updateAppointment: updateAppointmentBegin,
};

export default connect(null, mapDispatchToProps)(AppointmentData);
